export default __webpack_public_path__ + "static/media/Fondo-LandingCV.e69110ad.png";